const environment = {
    // apiUrl: 'https://localhost:44318/api/', // Local
    // apiReaderUrl: 'https://localhost:44373/api/', // Local
    
    apiUrl: 'https://sundae-api.objective-faraday.119-59-118-127.plesk.page/api/',  //VPS

    // apiUrl: 'https://smartgate-visitor-api.chememan.com/api/',  //PROD
    apiReaderUrl: 'http://localhost:83/api/' //PROD 
}
export default environment